module.exports = __webpack_public_path__ + "images/filtered.svg?05634735bafd09c7e4fcc4c9c8dbc7aa";